import React, {Component} from "react";
import TentangComponentOpenData from "../../../components/open_data/tentang/TentangComponentOpenData";

export class TentangOpenData extends Component{
    render(){
        return(
            <TentangComponentOpenData />
        )
    }
}

export default TentangOpenData;